module.exports = __webpack_public_path__ + "static/media/ex-about-us.3dc38cad.jpg";